import { render } from "./themes-own-profile.vue?vue&type=template&id=6e791a70"
import script from "./themes-own-profile.vue?vue&type=script&lang=js"
export * from "./themes-own-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__